import Vue from "vue";
import Vuex from "vuex";
import pathify, { make } from "vuex-pathify";

Vue.use(Vuex);

import auth from "./auth";
import _store from "./store";

const state = {
  configs: {
    bookingSlots: ["上午", "下午", "晚上"],
    bookingTypes: [{ value: "play", label: "计时" }, { value: "party", label: "派对" }, { value: "group", label: "团建" }],
    bookingTypeMap: {
      play: "计时",
      party: "派对",
      group: "团建"
    },
    bookingStatusMap: {
      pending: "待支付",
      booked: "已确认",
      in_service: "已入场",
      finished: "已结束",
      canceled: "已取消",
      pending_refund: "待退款"
    },
    bookingStatus: [
      { value: "pending", label: "待支付" },
      { value: "booked", label: "已确认" },
      { value: "in_service", label: "已入场" },
      { value: "finished", label: "已结束" },
      { value: "canceled", label: "已取消" },
      { value: "pending_refund", label: "待退款" }
    ],
    coupons: [],
    cardTypes: {},
    depositLevels: [],
    hourPrice: null,
    hourPriceRatio: []
  }
};

const mutations = make.mutations(state);
const store = new Vuex.Store({
  plugins: [pathify.plugin],
  state,
  mutations,
  modules: { auth, store: _store }
});

Vue.prototype.$store = store;

export default store;
